"use client";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-2xl bg-[#E11D24]/10 border border-[#E11D24]/20 flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-[#E11D24]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-3 font-ui">
          Something went wrong
        </h1>
        <p className="text-foreground/50 text-sm mb-8 font-body">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={reset}
          className="px-6 py-3 bg-[#E11D24] text-white rounded-xl text-sm font-medium hover:brightness-110 transition-all"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
